export const colorThemes = {
    dark: {
        colors: {
            background: '#2B2B2B',
            text: '#e0e0e0',
            title: '#e0e0e0',
            accent: '#9321cc'
        }
    }
}